export default __webpack_public_path__ + "static/media/Index.css.ddd668af.txt";